// extracted by mini-css-extract-plugin
export var colorSquare = "_rf-0";
export var danger = "_rf-5";
export var lightPink = "_rf-8";
export var neutralBlue = "_rf-7";
export var neutralYellow = "_rf-6";
export var normal = "_rf-1";
export var primary = "_rf-2";
export var primaryLight = "_rf-3";
export var solidBlack = "_rf-g";
export var solidGreen = "_rf-b";
export var solidLightBlue = "_rf-d";
export var solidNavy = "_rf-c";
export var solidOrange = "_rf-f";
export var solidPink = "_rf-e";
export var solidRed = "_rf-9";
export var solidYellow = "_rf-a";
export var success = "_rf-4";